import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TabbedSearchActiveTabState } from '../interface/tabbed-search.interface';

export const tabbedSearchActiveTabInitialState: TabbedSearchActiveTabState = {
  activeTabKey: "Product",
  activeTabValue: "Product",
  allTabs: {}
};

interface TabPayload {
  tabKey: string;
  tabValue: string;
  allTabs?: Record<string, string>;
}

const tabSlice = createSlice({
  name: 'tab',
  initialState: tabbedSearchActiveTabInitialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<string | TabPayload>) => {
      if (typeof action.payload === 'string') {
        // For backward compatibility
        state.activeTabKey = action.payload;
        state.activeTabValue = action.payload;
      } else {
        state.activeTabKey = action.payload.tabKey;
        state.activeTabValue = action.payload.tabValue;
      }
    },
    setAllTabs: (state, action: PayloadAction<Record<string, string>>) => {
      state.allTabs = action.payload;
    },
  },
});

export const { setActiveTab, setAllTabs } = tabSlice.actions;

/*----- CREATE REDUCER ------*/

export const tabbedSearchActiveTabReducer = tabSlice.reducer;
